exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table .trow:hover{cursor:pointer;background:#f5f5f5}.table h4{color:#3d3d3d;font-size:16px;margin:2px 0px 4px;font-weight:600}.table p{color:#9c9c9c;font-size:13px;margin:5px 0px 0px;max-height:39px;display:-webkit-box;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis}.table label.status{font-size:12px}.table label.status.active{background-color:#21ab58}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/rules-list/rule-table/rule-table.component.scss
// module id = 1376
// module chunks = 1